var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star icon small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Soft Star",
    d: "M4.86657 0.118531C4.88534 -0.0395103 5.11466 -0.0395103 5.13343 0.118531L5.29075 1.44435C5.49388 3.15634 6.84366 4.50612 8.55563 4.70925L9.88146 4.86657C10.0395 4.88534 10.0395 5.11466 9.88146 5.13343L8.55563 5.29075C6.84366 5.49388 5.49388 6.84366 5.29075 8.55563L5.13343 9.88146C5.11466 10.0395 4.88534 10.0395 4.86657 9.88146L4.70925 8.55563C4.50612 6.84366 3.15634 5.49388 1.44435 5.29075L0.118531 5.13343C-0.0395103 5.11466 -0.0395103 4.88534 0.118531 4.86657L1.44435 4.70925C3.15634 4.50612 4.50612 3.15634 4.70925 1.44435L4.86657 0.118531Z",
    fill: "#757473"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon3);
export default __webpack_public_path__ + "static/media/star-icon-3.160d391dfcfd2c56ade33368d1be8a2e.svg";
export { ForwardRef as ReactComponent };